import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { environment } from 'environments/environment';

@Injectable()
export class CoverageAprovalSearchService {

    constructor(private _http: HttpClient) { }

    get = (searchFilter: any): Observable<any> => {
        const url = `${environment.queryModel}CoverageApprovalSearch`;
        return this._http.post<any>(url, searchFilter);
    }
}